import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { WIDGET_DEFINITION_CRUD } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

const initialState: any = {}

const widgetDefinitionSlice = createSlice({
  name: 'widgetDefinition',
  initialState,
  reducers: {},
})

export default widgetDefinitionSlice

export const getwidgetDefinitionsListAPICall = createAsyncThunk(
  'widgetDefinition/getwidgetDefinitionsList',
  async (payload: any) => {
    const requestedData: any = WIDGET_DEFINITION_CRUD.LISTING(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)
